<template>
  <ol class="bibliography" @click.prevent.stop="openLink">
    <li v-for="item in bibliography" class="reference mb-3" v-html="item.text"></li>
  </ol>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState({bibliography: s => s.bibliography})
    },
    methods: {
      openLink(event) {
        if (event.target.tagName === 'A') {
          window.open(event.target.href, '_blank')
        }
      }
    }
  }
</script>